import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Box, Stack } from '@mui/material';
import { ContentCard, MobileBody, MobileTitle } from 'lib/mobileDesignSystem';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'services/redux/store';

import HomeProductCard from './HomeProductCard';
import HomeProductCardRow from './HomeProductCardRow';

const Home: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        flex: 1,
        minHeight: '100%',
        alignItems: 'center',
        py: 3,
        gap: 8,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <MobileTitle gutterBottom>¡Hola {user?.name}! 👋🏼</MobileTitle>
        <MobileBody color="text.secondary">Bienvenido a Pruff</MobileBody>
      </Box>

      <ContentCard
        header={{
          icon: <AccountBalanceIcon sx={{ fontSize: 20 }} />,
          title: 'Finanzas',
          description: 'Gestiona tus solicitudes, aprobaciones y más',
          clickable: true,
          onClick: () => navigate(`/finance`),
        }}
        headerWithBackground={false}
        sx={{ width: '100%', maxWidth: 400 }}
      >
        <HomeProductCardRow>
          <HomeProductCard
            title="Factoring"
            icon={<ReceiptLongIcon sx={{ fontSize: 24 }} />}
            to="/finance?tab=factoring"
            variant="primary"
          />
          <HomeProductCard
            title="Confirming"
            icon={<AssignmentIcon sx={{ fontSize: 24 }} />}
            to="/finance?tab=confirming"
            variant="primary"
          />
          <HomeProductCard
            title="Líneas de crédito"
            icon={<CreditCardIcon sx={{ fontSize: 24 }} />}
            to="/finance?tab=credit-line"
            variant="primary"
          />
        </HomeProductCardRow>
      </ContentCard>
    </Stack>
  );
};

export default Home;
